import unkownWeatherIcon from "assets/images/no-weather-available.webp";

class MeteoDto {
  static fromApi(data) {
    return populateWeatherData(data);
  }
}

const populateWeatherData = (weatherData) => {
  const finalDays = {};
  weatherData?.daily?.time?.forEach((dayTimestamp, index) => {
    const date = new Date(dayTimestamp * 1000);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    // Create the hour object
    const hourlyData = {};
    weatherData?.hourly?.time
      ?.slice(index * 24, index * 24 + 24)
      ?.forEach((hour, hourIndex) => {
        const hourDate = new Date(hour * 1000);
        const hourOfDay =
          hourDate.getHours().toString().padStart(2, "0") + ":00";

        const hourlyWeatherCode =
          weatherData.hourly.weatherCode?.[index * 24 + hourIndex];
        const hourlyWeatherIcon =
          weatherData?.weatherCodeDetails?.[hourlyWeatherCode]?.icon?.replace(
            "n.png",
            "d.png"
          ) || unkownWeatherIcon;

        hourlyData[hourOfDay] = {
          time: hour,
          timeAsDate: hourDate,
          temp: weatherData.hourly.temperature_2m?.[index * 24 + hourIndex],
          relativeHumidity:
            weatherData.hourly.relativeHumidity_2m?.[index * 24 + hourIndex],
          dewPoint: weatherData.hourly.dewPoint_2m?.[index * 24 + hourIndex],
          precipitationProbability:
            weatherData.hourly.precipitationProbability?.[
              index * 24 + hourIndex
            ],
          precipitation:
            weatherData.hourly.precipitation?.[index * 24 + hourIndex],
          rain: weatherData.hourly.rain?.[index * 24 + hourIndex],
          showers: weatherData.hourly.showers?.[index * 24 + hourIndex],
          snowfall: weatherData.hourly.snowfall?.[index * 24 + hourIndex],
          weatherCode: weatherData.hourly.weatherCode?.[index * 24 + hourIndex],
          cloudCover: weatherData.hourly.cloudCover?.[index * 24 + hourIndex],
          evapotranspiration:
            weatherData.hourly.evapotranspiration?.[index * 24 + hourIndex],
          et0FaoEvapotranspiration:
            weatherData.hourly.et0FaoEvapotranspiration?.[
              index * 24 + hourIndex
            ],
          windSpeed: weatherData.hourly.windSpeed_10m?.[index * 24 + hourIndex],
          windDirection:
            weatherData.hourly.windDirection_10m?.[index * 24 + hourIndex],
          windGusts: weatherData.hourly.windGusts_10m?.[index * 24 + hourIndex],
          isFrost: weatherData.hourly.isFrost?.[index * 24 + hourIndex],
          hourlyMainIcon: hourlyWeatherIcon,
        };
      });

    // Create the day object
    // Save the weather code for each day to find the mainIcon
    const weatherCode = weatherData.daily.weatherCode?.[index];
    const weatherIcon =
      weatherData?.weatherCodeDetails?.[weatherCode]?.icon?.replace(
        "n.png",
        "d.png"
      ) || unkownWeatherIcon;

    finalDays[`${year}-${month}-${day}`] = {
      time: dayTimestamp,
      timeAsDate: date,
      timeAsString: `${day}/${month}/${year}`,
      weatherCode: weatherCode,
      maxTemp: weatherData.daily.temperature_2mMax?.[index],
      minTemp: weatherData.daily.temperature_2mMin?.[index],
      midTemp: weatherData.daily.temperature_2mMean?.[index],
      sunrise: weatherData.daily.sunrise?.[index],
      sunset: weatherData.daily.sunset?.[index],
      daylightDuration: weatherData.daily.daylightDuration?.[index],
      sunshineDuration: weatherData.daily.sunshineDuration?.[index],
      frostsum: weatherData.daily.frostSum?.[index],
      relativeHumidity: weatherData.daily.relativeHumidity_2mMean?.[index],
      rainSum: weatherData.daily.rainSum?.[index],
      showersSum: weatherData.daily.showersSum?.[index],
      snowfallSum: weatherData.daily.snowfallSum?.[index],
      precipitationHours: weatherData.daily.precipitationHours?.[index],
      precipitationSum: weatherData.daily.precipitationSum?.[index],
      precipitationProbabilityMax:
        weatherData.daily.precipitationProbabilityMax?.[index],
      windSpeed: weatherData.daily.windSpeed_10mMax?.[index],
      windGusts: weatherData.daily.windGusts_10mMax?.[index],
      windDirection: weatherData.daily.windDirection_10mDominant?.[index],
      shortwaveRadiationSum: weatherData.daily.shortwaveRadiationSum?.[index],
      evapotranspiration: weatherData.daily.et0FaoEvapotranspiration?.[index],
      gdd: weatherData.daily.gdd?.[index],
      mainIcon: weatherIcon,
      hourly: hourlyData,
    };
  });

  return finalDays;
};

export default MeteoDto;
